import { RootState } from '../store';

export const commerceSelector = (state: RootState) => state.commerce;
